jQuery(function($){
    

    $('.nav-menu-popup__menu-item > span').on('click', function(){
        if ($(this).hasClass('active')){
            $(this).removeClass('active');
            $(this).siblings('div').css('display', 'none');
        }
        else{
            $(this).addClass('active');
            $(this).siblings('div').css('display', 'flex');
        }
    });



});